import { H1 } from '@/common/ui'

export const ValuesGridItem = ({ label, value }: { label: string; value: string }) => (
    <div className="pr-8 mt-8 pb-6 border-b-1 ml-8 pl-0 lg:border-r-1 lg:border-b-0 border-gray last:border-b-0 last:border-r-0">
        <H1 className="mb-1">{value}</H1>
        <span className="text-accent-foreground text-sm">{label}</span>
    </div>
)
